import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";
const StatesState = (props) => {
  const StatesStateSVG = () => {
    const themeDefault = useSelector((state) => state.themeDefault);

    const predefinedSizes = {
      small: themeDefault?.info?.newConfig?.emptyStateSizes?.small,
      medium: themeDefault?.info?.newConfig?.emptyStateSizes?.medium,
      large: themeDefault?.info?.newConfig?.emptyStateSizes?.large,
    };

    return (
      <svg
        width={predefinedSizes[props?.size] || 150}
        height={predefinedSizes[props?.size] || 150}
        viewBox="0 0 150 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1593_21699)">
          <path
            opacity="0.02"
            d="M120 53.5298V135.37C107.036 145.148 91.2387 150.438 75 150.438C58.7613 150.438 42.9645 145.148 30 135.37V53.5298C34.2435 53.5298 38.3131 51.8441 41.3137 48.8435C44.3143 45.8429 46 41.7732 46 37.5298H104C104 41.7732 105.686 45.8429 108.686 48.8435C111.687 51.8441 115.757 53.5298 120 53.5298Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            opacity="0.08"
            d="M150 75.2598C150.01 86.9049 147.304 98.3919 142.096 108.808C136.888 119.223 129.322 128.281 120 135.26V53.2598C115.757 53.2598 111.687 51.5741 108.686 48.5735C105.686 45.5729 104 41.5032 104 37.2598H46C46 41.5032 44.3143 45.5729 41.3137 48.5735C38.3131 51.5741 34.2435 53.2598 30 53.2598V135.26C19.7726 127.589 11.6757 117.432 6.47817 105.752C1.28063 94.0717 -0.845023 81.2569 0.303074 68.5244C1.45117 55.7918 5.8349 43.564 13.038 33.0022C20.2411 22.4403 30.0244 13.895 41.459 8.17774C52.8936 2.46045 65.5998 -0.239051 78.3711 0.335578C91.1425 0.910207 103.555 4.73989 114.43 11.461C125.305 18.182 134.281 27.5714 140.507 38.7374C146.732 49.9035 150 62.4755 150 75.2598Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            d="M98.9999 78.2599C99.0031 83.6684 97.1795 88.9193 93.8247 93.1615C90.4698 97.4037 85.7805 100.388 80.5169 101.632C75.2533 102.875 69.7241 102.304 64.8257 100.011C59.9273 97.7183 55.9469 93.8382 53.5299 88.9999L60.8199 81.7099L69.8199 90.7099L83.8899 76.5399V83.3699L88.1499 79.1099V69.1099H78.1499L73.8899 73.3699H80.7199L69.7799 84.2599L60.7799 75.2599L51.7799 84.2599C50.9169 80.9579 50.7681 77.5098 51.3435 74.1457C51.9188 70.7816 53.205 67.5789 55.1162 64.7513C57.0275 61.9238 59.5198 59.5363 62.4269 57.7484C65.334 55.9604 68.5891 54.813 71.9748 54.3828C75.3605 53.9526 78.799 54.2495 82.0609 55.2536C85.3228 56.2577 88.333 57.9459 90.8907 60.2057C93.4483 62.4654 95.4946 65.2447 96.893 68.358C98.2914 71.4713 99.0097 74.847 98.9999 78.2599Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            opacity="0.16"
            d="M91 111.26C91 112.055 90.6839 112.818 90.1213 113.381C89.5587 113.944 88.7957 114.26 88 114.26H62C61.2044 114.26 60.4413 113.944 59.8787 113.381C59.3161 112.818 59 112.055 59 111.26C59 110.464 59.3161 109.701 59.8787 109.138C60.4413 108.576 61.2044 108.26 62 108.26H88C88.7957 108.26 89.5587 108.576 90.1213 109.138C90.6839 109.701 91 110.464 91 111.26ZM97 120.26H53C52.2044 120.26 51.4413 120.576 50.8787 121.138C50.3161 121.701 50 122.464 50 123.26C50 124.055 50.3161 124.818 50.8787 125.381C51.4413 125.944 52.2044 126.26 53 126.26H97C97.7957 126.26 98.5587 125.944 99.1213 125.381C99.6839 124.818 100 124.055 100 123.26C100 122.464 99.6839 121.701 99.1213 121.138C98.5587 120.576 97.7957 120.26 97 120.26Z"
            fill={themeDefault?.info?.colorPrimary}
          />
        </g>
        <defs>
          <clipPath id="clip0_1593_21699">
            <rect
              width="150"
              height="150.14"
              fill="white"
              transform="translate(0 0.259766)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={StatesStateSVG} />;
};

export default StatesState;
